import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-v-small', 'LetterVSmall', [["path",{"d":"M10 8l2 8l2 -8"}]]);